module.exports = ".input-center {\r\nwidth:500px;\r\nheight:0;\r\ntop:0;\r\nleft:0;\r\nright:0;\r\nbottom:0;\r\nmargin:auto;\r\nposition:absolute;\r\n}\r\n"